var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-tabs-slots"},[_c('div',[_c('am-tabs',{class:_vm.classes,attrs:{"tabs":_vm.tabs,"minWidth":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._t("default",null,{"selected":_vm.selected})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }